import * as SQLite from 'expo-sqlite';
import { Platform } from 'react-native';

let db;
if(Platform.OS !== 'web')
  db = SQLite.openDatabase('database2.db');

const initDatabase = () => {
  if(Platform.OS === 'web')
    return;
  return new Promise((resolve, reject) => {
    db.transaction((tx) => {
      tx.executeSql(
        'CREATE TABLE IF NOT EXISTS requests (id INTEGER PRIMARY KEY, data TEXT);',
        [],
        () => {
          console.log('Table created successfully');
          resolve(); // Resolve the promise when table creation is complete
        },
        (_, error) => {
          console.error('Error creating table:', error);
          reject(error); // Reject the promise on error
        }
      );
    });
  });
};

const saveRequest = (request) => {
  if(Platform.OS === 'web')
    return;
  return new Promise((resolve, reject) => {
    if(!request || !request.id){
      reject();
      return;
    }
    db.transaction((tx) => {
      tx.executeSql(
        'INSERT OR REPLACE INTO requests (id, data) VALUES(?, ?);',
        [request.id, JSON.stringify(request)],
        () => {
          console.log('Request saved successfully ' + request.id);
          resolve();
        },
        (_, error) => {
          console.error('Error saving request:', error);
          reject(error);
        }
      );
    });
  });
}

const getRequests = () => {
  if(Platform.OS === 'web')
    return;
  return new Promise(async (resolve, reject) => {
    try {
      db.transaction((tx) => {
        tx.executeSql(
          'SELECT * FROM requests;',
          [],
          (_, result) => {
            const items = result.rows._array.map(request => JSON.parse(request.data));
            resolve(items);
          },
          (_, error) => {
            console.error('Error retrieving items:', error);
            reject(error);
          }
        );
      });
    } catch (error) {
      reject(error);
    }
  });
};

const getRequestById = (id) => {
  if(Platform.OS === 'web')
    return;
  return new Promise(async (resolve, reject) => {
    try {
      await initDatabase(); // Ensure the database is initialized before querying
      db.transaction((tx) => {
        tx.executeSql(
          'SELECT * FROM requests WHERE id=?;',
          [id],
          (_, result) => {
            const request = result.rows._array.map(request => JSON.parse(request.data))[0]??{};
            resolve(request);
          },
          (_, error) => {
            console.error('Error retrieving items:', error);
            reject(error);
          }
        );
      });
    } catch (error) {
      reject(error);
    }
  });
};

export { db, initDatabase, saveRequest, getRequests, getRequestById };